import { UserState, UserActions, USER_ACTIONS_TYPES } from './types'

const INITIAL_STATE: UserState = {
  attributes: {
    sub: '',
    name: '',
    email: '',
    gender: 0,
    phone_number: '',
    birthdate: '',
    password: '',
    picture: '',
  },
  intents: [],
}

export default function reducer(
  state = INITIAL_STATE,
  action: UserActions,
): UserState {
  switch (action.type) {
    case USER_ACTIONS_TYPES.USER_SET_DATA: {
      const { payload } = action

      return { ...state, ...payload }
    }

    case USER_ACTIONS_TYPES.USER_RESET_DATA: {
      return { ...INITIAL_STATE }
    }

    default:
      return state
  }
}
